export class UsersInviteModel {

    public emails: string[];
    public greeting: string;

}


// WEBPACK FOOTER //
// ./src/app/core/models/usersInviteModel.model.ts